import {
	type Component,
	type ComponentProps,
	type JSXElement,
	Suspense,
	splitProps
} from "solid-js";
import { tv } from "tailwind-variants";

const styles = tv({
	base: "h-full w-full shrink-0 animate-pulse rounded-lg",
	variants: {
		color: {
			dark: "bg-gray-800",
			light: "bg-background-gray"
		}
	}
});
type SkeletonVariants = "dark" | "light";
type SkeletonProps = {
	variant?: SkeletonVariants;
} & Omit<ComponentProps<"div">, "children">;
export const Skeleton: Component<SkeletonProps> = (props) => {
	const [rest, native] = splitProps(props, ["class", "variant"]);
	return <div class={styles({ color: rest.variant || "dark", class: rest.class })} {...native} />;
};
export const SuspenseSkeleton: Component<{ children: JSXElement } & SkeletonProps> = (props) => {
	const [rest, native] = splitProps(props, ["children"]);
	return <Suspense fallback={<Skeleton {...native} />}>{rest.children}</Suspense>;
};
